<i18n>
{
    "en_US": {
        "cancel": "Cancel",
        "empty-friend-list": "You don't have any friend yet, use the 'plus' above to add some.",
        "error-no-email": "No email selected",
        "explain-no-email": "You need to add an email using the \"+\" button, or select an existing email in the list",
        "ok": "OK",
        "search-or-add": "Search in friend's list or add email",
        "send": "Send",
        "success": "Success",
        "success-send-email": "Email sent",
        "title": "Add one/many recipient"
    },
    "fr_FR": {
        "cancel": "Annuler",
        "empty-friend-list": "Vous n'avez pas encore ajouté d'amis, utilisez le 'plus' au dessus pour en ajouter.",
        "error-no-email": "Aucun email sélectionné",
        "explain-no-email": "Vous devez ajouter un email a l'aide du bouton \"+\", ou sélectionner un email existant dans la liste",
        "ok": "OK",
        "search-or-add": "Rechercher dans votre liste d'amis ou ajouter un email",
        "send": "Envoyer",
        "success": "Succès",
        "success-send-email": "Email envoyé avec succès",
        "title": "Ajouter un/des destinaitaire(s)"
    }
}
</i18n>

<template>
    <div class="email-menu-container" v-bind:class="{ active: isModalEmailVisible }">
        <h4 v-text="$t('title')"></h4>

        <div class="input-group">
            <input type="text" class="form-control bmb-control search" :placeholder="$t('search-or-add')" v-model="search" />
            <span class="input-group-btn">
                <button class="btn btn-primary add" type="button" v-on:click="addFriend">
                    <i class="fa fa-plus"></i>
                </button>
            </span>
        </div>

        <div class="emails-of-friends-container">
            <div v-if="pending.refresh_user_account" class="text-center loading">
                <loader-basic-spinner class="blue large" />
            </div>
            <div v-else>
                <ul v-if="hasFriend">
                    <li v-bind:key="email" v-for="email in this.searched">
                        <a class="switch">
                            <button-on-off v-on:switch="switchFriendActive" v-bind:id="email" v-bind:checked="friendIsActive(email)" />
                        </a>
                        <a class="email">
                            {{email}}
                        </a>
                        <a class="delete">
                            <button-tiny-delete-confirm v-on:confirm="removeFriend" v-bind:id="email" />
                        </a>
                    </li>
                </ul>
                <div v-else class="no-friend text-center">
                    <small v-text="$t('empty-friend-list')"></small>
                </div>
            </div>
        </div>

        <p class="text-center">
            <a class="btn btn-default" v-on:click="hide" v-text="$t('cancel')"></a>
            <button class="btn btn-primary send" v-on:click="send" v-bind:disabled="busy">
                <loader-basic-spinner v-if="busy" />
                <a v-else v-text="$t('send')"></a>
            </button>
        </p>
    </div>
</template>

<script>
    import ButtonOnOff from "buttons/OnOff";
    import ButtonTinyDeleteConfirm from "buttons/TinyDeleteConfirm";
    import LoaderBasicSpinner from "loaders/BasicSpinner";
    import { mapState, mapMutations, mapActions } from "vuex";

    export default {
        name: "Email",
        data: function() {
            return {
                busy: false,
                friends: [],
                search: ""
            };
        },
        components: {
            ButtonOnOff,
            ButtonTinyDeleteConfirm,
            LoaderBasicSpinner
        },
        computed: {
            searched: function() {
                if (!this.search) {
                    return this.authentication.emails_of_friends;
                } else {
                    const results = [];
                    for (let i = 0, l = this.authentication.emails_of_friends.length; i < l; i++) {
                        if (this.authentication.emails_of_friends[i].indexOf(this.search) !== -1) {
                            results.push(this.authentication.emails_of_friends[i]);
                        }
                    }
                    return results;
                }
            },
            hasFriend: function() {
                return this.authentication.emails_of_friends.length > 0;
            },
            ...mapState("user", ["authentication", "pending"]),
            ...mapState("note", ["selectedNote"]),
            ...mapState("application", ["isModalEmailVisible"])
        },
        watch: {
            isModalEmailVisible: function(newValue) {
                // When the system load the menu,
                // we ask for server request refresh.
                if (newValue) {
                    this.refreshUserAccount()
                        .then(function() {
                            this.$Progress.finish();
                        }.bind(this))
                        .catch(function() {});
                }
            }
        },
        methods: {
            hide: function() {
                // Resetting everything
                this.search = "";
                let i = this.friends.length;
                while (i--) {
                    this.friends.splice(i, 1);
                }

                // Hiding menu
                this.hideModalEmail();
            },
            send: function() {
                const emails = this.friends;
                // If we got email, we send
                if (emails.length > 0) {
                    this.busy = true;
                    this.$http.post("/notes/email", {
                        emails: this.friends,
                        title: this.selectedNote.title,
                        content: this.selectedNote.content
                    }).then(function() {
                        this.busy = false;
                        this.hide();
                        this.$Progress.finish();
                        swal({
                            title: this.$t("success"),
                            text: this.$t("success-send-email"),
                            showCancelButton: false,
                            confirmButtonClass: "btn-primary",
                            confirmButtonText: this.$t("ok"),
                            closeOnConfirm: true
                        });
                    }.bind(this)).catch(function() {
                        this.busy = false;
                        this.hide();
                    }.bind(this));
                }
                // If not, we show a message, and reshow it after...
                else {
                    this.hideModalEmail();
                    swal({
                        title: this.$t("error-no-email"),
                        text: this.$t("explain-no-email"),
                        showCancelButton: false,
                        confirmButtonClass: "btn-primary",
                        confirmButtonText: this.$t("ok"),
                        closeOnConfirm: true
                    }, function() {
                        this.showModalEmail();
                    }.bind(this));
                }
            },
            switchFriendActive: function(email, state) {
                const l = email.toLowerCase();
                if (state && !this.friends.indexOf(l) >= -1) {
                    this.friends.push(l);
                } else {
                    let i = this.friends.length;
                    while (i--) {
                        if (this.friends[i] === l) {
                            this.friends.splice(i, 1);
                        }
                    }
                }
            },
            friendIsActive: function(email) {
                return this.friends.indexOf(email.toLowerCase()) >= 0;
            },
            addFriend: function() {
                const search = $(this.$el).find(".search"),
                      email = search.val();

                if (email) {
                    this.addFriends({
                        emails: [email]
                    }).then(function() {
                        this.$Progress.finish();
                        this.search = "";
                    }.bind(this))
                    .catch(function() {});
                }
            },
            removeFriend: function(email) {
                this.removeFriends({
                    emails: [email]
                }).then(function() {
                    this.$Progress.finish();
                    // We permanently remove it from the friend switched "on"
                    this.switchFriendActive(email, false);
                }.bind(this))
                .catch(function() {});
            },
            ...mapActions("user", ["addFriends", "removeFriends", "refreshUserAccount"]),
            ...mapMutations("application", ["hideModalEmail", "showModalEmail"])
        }
    }
</script>

<style scoped>
    .email-menu-container {
        display: none;
        position: fixed;
        left: 50%;
        top: 50%;
        height: 500px;
        width: 600px;
        margin-left: -300px;
        margin-top: -250px;
        z-index: 11;
        background: #fff;
        color: #212529;
        padding: 17px;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        -webkit-transition: all .2s ease;
        -moz-transition: all .2s ease;
        -ms-transition: all .2s ease;
        transition: all .2s ease;
    }

    h4 {
        margin-bottom: 20px;
    }

    .email-menu-container.active {
        animation: showSweetAlert .3s;
        display: block;
    }

    input {
        background-image: none;
        padding-left: 10px;
        padding-right: 10px;
    }
    input, input:focus {
        border: 1px solid #e4eaec !important;
        border-bottom: 0 none !important;
    }

    .no-friend {
        padding-top: 25px;
        color: #888;
    }

    .form-control, input::placeholder {
        color: #AAA;
        font-weight: 100;
        line-height: 26px !important;
    }

    .emails-of-friends-container {
        height: calc(100% - 160px);
        border: 1px solid #e4eaec;
        margin-bottom: 20px;
        overflow-y: auto;
    }
    .add {
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
        margin: 0;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .btn-primary, .btn-default {
        text-transform: uppercase !important;
    }
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    li {
        padding: 0;
        border-bottom: 1px solid #e4eaec;
        display: flex;
    }
    li:nth-child(2n) {
        background: #f1fafe;
    }

    .switch {
        margin-left: 15px;
        display: block;
        margin-right: 10px;
    }
    .email {
        flex: 1;
        padding-top: 10px;
        padding-bottom: 10px;
        color: #555 !important;
    }
    .delete {
        line-height: 24px;
        font-size: 16px;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-right: 15px;
    }
    .send[disabled] {
        margin-bottom: 0;
        width: 60px;
        height: 36px;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    @media screen and (max-width: 600px), screen and (max-height: 500px) {
        .email-menu-container {
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            margin-left: 0;
            margin-top: 0;
            -webkit-border-radius: 0px;
            -moz-border-radius: 0px;
            border-radius: 0px;
        }
    }

    /* Spinner */
    .loading {
        padding-top: 50px;
    }
    .btn-primary >>> .loader-basic-spinner div {
        margin: 0;
    }
</style>
